import { render } from "./DesignationScreenPrivileges.vue?vue&type=template&id=67cfe1e7&scoped=true"
import script from "./DesignationScreenPrivileges.js?vue&type=script&lang=js"
export * from "./DesignationScreenPrivileges.js?vue&type=script&lang=js"

import "./DesignationScreenPrivileges.vue?vue&type=style&index=0&id=67cfe1e7&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67cfe1e7"]])

export default __exports__